// 开发环境域名
//https://php-b2csaas.yixiangonline.com
const host_development = 'https://saas.nblover.cn'

export default {
    // 版本
    version: '3.1.0',
    baseURL: process.env.NODE_ENV == 'production' ? 'https://saas.nblover.cn' : host_development,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
